var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud09(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 313.778,
    height: 205.221,
    viewBox: "0 0 313.778 205.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M273.54 97.293c-4.61-33.43-33.275-59.18-67.973-59.18-1.61 0-3.204.074-4.787.185.002-.103.008-.202.008-.304 0-15.852-12.848-28.698-28.697-28.698-8.138 0-15.48 3.394-20.703 8.836C139.16 6.88 122.847 0 104.922 0 67.015 0 36.284 30.73 36.284 68.638c0 2.834.192 5.62.525 8.364C15.442 83.985 0 104.067 0 127.768c0 29.498 23.914 53.41 53.41 53.41h57.394c13.165 8.865 29.02 14.043 46.088 14.043 17.067 0 32.922-5.177 46.087-14.043h68.836c23.177 0 41.964-18.788 41.964-41.964-.002-22.598-17.865-41.015-40.24-41.92z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud09);
export default __webpack_public_path__ + "static/media/cloud-09.f19474bf1f3abc97bf0a35bfce31daae.svg";
export { ForwardRef as ReactComponent };